import { FC } from 'react';
import { Screen } from '../../../theme';
import SignedImage from '../../AWS/SignedImage';
import { Spacing, Text } from '../../ui';
import { LineRoundedChevron } from '../icons/exported/lineRoundedChevron';
import LineRoundedWrapper from '../icons/exported/lineRoundedWrapper';
import { Container, FullNameContainer, ImageContainer, Online, Root } from './style';

interface AvatarProps {
  size?: number;
  image?: string;
  signedImage?: boolean;
  fullName?: string;
  isOnline?: boolean;
  isActive?: boolean;
  showChevron?: boolean;
  overlap?: boolean;
  showFullNameBreakPoint?: Screen;
  imageSize?: string;
}
const Avatar: FC<AvatarProps> = ({
  showFullNameBreakPoint,
  size,
  image,
  signedImage = true,
  fullName,
  isOnline,
  isActive,
  showChevron = false,
  imageSize,
  overlap = false,
}) => {
  return (
    <Root>
      <Container {...{ overlap, size }}>
        <ImageContainer imageSize={imageSize}>
          {image ? (
            <SignedImage alt={fullName} src={image} skipUrlFetching={!signedImage} objectFit="fill" />
          ) : (
            <SignedImage alt={fullName} src={'/assets/default-profile.webp'} skipUrlFetching={true} objectFit="fill" />
          )}
        </ImageContainer>
        {isOnline && <Online />}
      </Container>
      {fullName && (
        <FullNameContainer showFullNameBreakPoint={showFullNameBreakPoint}>
          <Spacing left="xs" />
          <Text weight="light" size="xs" color={isActive ? 'primary' : 'text'}>
            {fullName}
          </Text>
          {showChevron && (
            <LineRoundedWrapper>
              <LineRoundedChevron />
            </LineRoundedWrapper>
          )}
        </FullNameContainer>
      )}
    </Root>
  );
};

export default Avatar;
